// extracted by mini-css-extract-plugin
export default {"wrap":"UserCustomerUsers_wrap__YQEEI"};